export default __webpack_public_path__ + "static/media/lgHeroBanner.62cd9078.png";